var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading.length > 0)?_c('div',{staticClass:"loading"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#5b6cff","size":"70","width":"7"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }